import ConsentimentoContext from "context/consentimentoContext";
import { useContext } from "react";

export const useConsentimentoContext = () => useContext(ConsentimentoContext);
